<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <compra-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import CompraShowData from "./CompraShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "CompraShow",
        components: {CrudShow, CompraShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.compra.showing',
            }
        },
    }
</script>

